import {RatingDistributionType} from "../../definitions/types";
import {RatingDistributionElementModel} from "./ratingDistributionElementModel";

export class RatingDistributionModel {
    private readonly _count: number;
    private readonly _oneStar: number;
    private readonly _twoStar: number;
    private readonly _threeStar: number;
    private readonly _fourStar: number;
    private readonly _fiveStar: number;

    constructor(public readonly ratingDistributionType: RatingDistributionType) {
        this._count = ratingDistributionType.oneStar + ratingDistributionType.twoStar + ratingDistributionType.threeStar + ratingDistributionType.fourStar + ratingDistributionType.fiveStar;
        this._oneStar = ratingDistributionType.oneStar;
        this._twoStar = ratingDistributionType.twoStar;
        this._threeStar = ratingDistributionType.threeStar;
        this._fourStar = ratingDistributionType.fourStar;
        this._fiveStar = ratingDistributionType.fiveStar;
    }

    public get count(): number {
        return this._count;
    }

    /**
     * @method oneStar
     * @description Returns the oneStar rating distribution element (count and percentage).
     * @returns {RatingDistributionElementModel}
     */
    public get oneStar(): RatingDistributionElementModel {
        return new RatingDistributionElementModel(this._oneStar, this._count)
    }

    /**
     * @method twoStar
     * @description Returns the twoStar rating distribution element (count and percentage).
     * @returns {RatingDistributionElementModel}
     */
    public get twoStar(): RatingDistributionElementModel {
        return new RatingDistributionElementModel(this._twoStar, this._count);
    }

    /**
     * @method threeStar
     * @description Returns the threeStar rating distribution element (count and percentage).
     * @returns {RatingDistributionElementModel}
     */
    public get threeStar(): RatingDistributionElementModel {
        return new RatingDistributionElementModel(this._threeStar, this._count);
    }

    /**
     * @method fourStar
     * @description Returns the fourStar rating distribution element (count and percentage).
     * @returns {RatingDistributionElementModel}
     */
    public get fourStar(): RatingDistributionElementModel {
        return new RatingDistributionElementModel(this._fourStar, this._count);
    }

    /**
     * @method fiveStar
     * @description Returns the fiveStar rating distribution element (count and percentage).
     * @returns {RatingDistributionElementModel}
     */
    public get fiveStar(): RatingDistributionElementModel {
        return new RatingDistributionElementModel(this._fiveStar, this._count);
    }
}